import React from "react";
import "./App.scss";
import Routing from "./Routes";
import { MessagePayload, onMessage } from "firebase/messaging";
import toast, { Toast } from "react-hot-toast";
import { messaging, requestNotificationPermission } from "./lib/firebase-messaging";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { setToStorage, STORAGE_KEYS } from "./helpers";


const App = () => {
  const navigate = useNavigate();


  useEffect(() => {
    requestNotificationPermission().then((token) => {
      console.log("FCM Token:", token);
      setToStorage(STORAGE_KEYS.fcmToken, token || "");
    }).catch((error) => {
      console.error("FCM Token generation failed:", error);
    });

    const handleMessage = (payload: MessagePayload) => {
      toast(
        (t: Toast) => (
          <div
            style={{
              width: "380px",
              background: "#fff",
              boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
              borderRadius: "16px",
              padding: "16px 20px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              border: "1px solid #f2f2f2",
              cursor: "pointer",
              transition: "all 0.3s ease",
            }}
            role="button"
            onClick={() => {
              const url = payload?.data?.url;
              if (url) {
                navigate(url);
              }
              toast.dismiss(t.id);
            }}
          >
            <div style={{ flex: 1, paddingRight: "12px" }}>
              <h4
                style={{
                  margin: "0 0 6px 0",
                  fontSize: "16px",
                  fontWeight: "700",
                  color: "#1a1a1a",
                }}
              >
                {payload.notification?.title}
              </h4>
              <p
                style={{
                  margin: 0,
                  fontSize: "14px",
                  color: "#4d4d4d",
                  lineHeight: "1.5",
                }}
              >
                {payload.notification?.body}
              </p>
            </div>
            <button
              onClick={(e) => {
                e.stopPropagation();
                toast.dismiss(t.id);
              }}
              style={{
                border: "none",
                background: "transparent",
                cursor: "pointer",
                padding: "4px",
                display: "flex",
                opacity: 0.5,
                borderRadius: "50%",
                transition: "background 0.2s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = "#f5f5f5")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background = "transparent")
              }
            >
              <CloseIcon sx={{ fontSize: 18 }} />
            </button>
          </div>
        ),
        {
          duration: 8000,
          position: "top-right",
          style: {
            background: "transparent",
            boxShadow: "none",
            padding: 0,
            maxWidth: "none",
            borderRadius: "16px",
          },
        },
      );
    };

    if (messaging) {
      const unsubscribe = onMessage(messaging, (payload: MessagePayload) => {
        handleMessage(payload);
      });
      return () => unsubscribe();
    }
  }, [navigate]);


  return <Routing />;
};

export default App;
